// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/font-awesome/css/font-awesome.min.css
// module id = 1142
// module chunks = 0